import React, { Component } from 'react'
import './Footer.css'

export default class Footer extends Component {
  render() {
    return (
      <div className='footer'>
        <hr />
        <div className='directory'>
          <div className='directory-section-list'>
            <div className='directory-section-title'>Shop and Learn</div>
            <a href=''>Store</a>
            <a href=''>Project0</a>
            <a href=''>Project1</a>
          </div>
          <div className='directory-section-list'>
            <div className='directory-section-title'>Prayogshala Store</div>
            <a href=''>Find a Store</a>
          </div>
          <div className='directory-section-list'>
            <div className='directory-section-title'>About Prayogshala</div>
            <a href=''>Ethics and Compliance</a>
            <a href=''>Contact Prayogshala</a>
          </div>
        </div>
        <div className='footer-shop'>
          <div className='footer-shop-title'>More ways to shop:</div>
          <div className='footer-shop-body'>
            <a href=''>Find a Prayogshala Store</a> or{' '}
            <a href=''>other retailer</a> near you.
          </div>
        </div>
        <hr />
        <div className='footer-legal'>
          <div className='footer-legal-copyright'>
            Copyright &copy; 2023 Adarsha Prayogshala Pvt. Ltd. All rights
            reserved.
          </div>
          <div className='footer-legal-links'>
            <a href=''>Privacy Policy</a> | <a href=''>Terms of Use</a> |{' '}
            <a href=''>Sales and Refunds</a> | <a href=''>Legal</a> |{' '}
            <a href=''>Site Map</a>
          </div>
          <div className='footer-locale'>
            <a href=''>नेपाली</a> | English
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/footer/Footer.js